import React from 'react'
import './footer.css'
import {BsTwitter} from 'react-icons/bs'
import {FaFacebookF} from 'react-icons/fa'
import {SiDiscord} from 'react-icons/si'
const footer = () => {
  return (
    <footer>
      <a href='#logo' className='footer__logo'>MARKPAUL</a>
      <ul className='permalinks'>
        <li><a href="#home">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#testimonials">Testimonials</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>


      <div className="footer__socials">
        <a href="https://facebook.com/maqii.paul/"><FaFacebookF/></a>
        <a href="https://twitter.com/muthaura_jr"><BsTwitter/></a>
        <a href="https://discordapp.com/users/997202503093473321"><SiDiscord/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; 2023 MARKPAUL. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default footer
